import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CandidateUploadActionsUnion, CandidateUploadActionTypes } from './candidate-upload.actions';

export interface CandidateUploadState {
  savedCandidateId: number;
}

export const initialState: CandidateUploadState = {
  savedCandidateId: 0,
};

export function candidateUploadReducer(state = initialState, action: CandidateUploadActionsUnion): CandidateUploadState {
  if (action.type === CandidateUploadActionTypes.UploadCandidatesSelect) {
    return { savedCandidateId: action.payload };
  } else {
    return state;
  }
}

export const getCandidateUploadState = createFeatureSelector<CandidateUploadState>('candidateUpload');

export const getUploadCandidateId = createSelector(getCandidateUploadState, (state: CandidateUploadState) => state.savedCandidateId);
